
































































































import settings from '@/settings'
import Menus from '@/components/menus'
import q from '@/graphql/query'
import m from '@/graphql/mutation'
import n from '@/utils/notifications'
import t from '@/utils/tools'
import af from '@/utils/authorized_formats'

export default {
    name: 'GED'

    components: { Menus }

    data: ()->
        true: true
        false: false
        errors: {}
        selected_user: ''
        app_users: []
        paths:[
            ["", 'Accueil']
        ]
        ged_files: []
        search: ''
        loading: true
        folder_uid: ''
        file_dialog_visible: false
        folder_dialog_visible: false
        max_filesize: af['file']['filename']['max_filesize']/1024/1024
        file:
            uid: ''
            folder_uid: ''
            name: ''
            private: false
            file_data: ''
            file_name: ''
            file_size: 0
            file_type: ''
        folder:
            uid: ''
            parent_uid: ''
            name: ''
            private: false

    computed:
        data_filtered: ()->
            self = @
            data = @ged_files.filter (x) ->
                !self.search || x.name.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,"").includes(self.search.toLowerCase()) || x.name.toLowerCase().includes(self.search.toLowerCase())
            return data

        file_modal_sub_title: ()->
            title = "Ajouter"
            if @file.uid != ''
                title = "Editer"
            return title

        folder_modal_sub_title: ()->
            title = "Ajouter"
            if @folder.uid != ''
                title = "Editer"
            return title

    methods:
        top_buttons: ()->
            if @folder_uid in ['formation', 'graduate', 'payslip', 'prohazard', 'userjob', 'uservoucher', 'interview']
                return false
            return true

        file_icon: (type_label)->
            try
                icon = af['file']['types'][type_label]['icon']
            catch e
                icon = af['file']['types']['other']['icon']
            return icon

        get_errors: (fieldName)->
            ret = null
            if @errors[fieldName]?
                ret = @errors[fieldName][0]
            return ret

        change_selected_user: ()->
            # console.log "CHANGE SELECTED USER", @selected_user
            @loading = true
            @folder_uid = ''
            @reset_paths()
            @get_ged_files()
            return

        change_breadcrumb: (index, data)->
            # console.log "CHANGE BREADCRUMB ", index, data
            @folder_uid = data[0]
            @paths = @paths.slice(0, index+1)
            @get_ged_files()
            return

        reset_paths: ()->
            @paths = [
                ["", 'Accueil']
            ]
            return

        go_back: ()->
            @paths.pop()
            @folder_uid = @paths[@paths.length-1][0]
            @get_ged_files()
            return

        display: (row)->
            # console.log "DISPLAY ", row.uid, row.name, row.type_label
            if row.type_label == "Dossier"
                @paths.push([row.uid, row.name])
                @folder_uid = row.uid
                @get_ged_files()
            else
                @download_file(row)
            return

        handle_file_change: (file, fileList)->
            # console.log "HANDLE FILE CHANGE ", file.size
            is_good_size = file.size < af['file']['filename']['max_filesize']

            if !is_good_size
                n.file_error('Erreur', 'Le fichier ne peut pas excéder '+@max_filesize+'Mo.')
                fileList.pop()
                return

            self = @
            if fileList.length > 1
                fileList.splice(0,1)
            reader = new FileReader()
            reader.onload = (e)->
                # console.log 'E', e
                self.file.file_data = e.target.result
                self.file.file_name = file.name
                self.file.file_size = file.size
                if file.raw.type.split('/')[0] in ['application', 'text']
                    try
                        self.file.file_type = af['application_types'][file.raw.type]
                    catch e
                        self.file.file_type = 'other'
                else
                    self.file.file_type = file.raw.type.split('/')[0]
            reader.readAsDataURL(file.raw)
            # console.log "FILE", @file
            return

        download_file: (row)->
            url = settings.media_url+row.link
            filename = row.name
            t.download_file(url, filename)
            return
            
        reset_file: ()->
            @file = {
                uid: ''
                folder_uid: ''
                name: ''
                private: false
                file_data: ''
                file_name: ''
                file_size: 0
                file_type: ''
            }
            return

        reset_folder: ()->
            @folder = {
                uid: ''
                parent_uid: ''
                name: ''
                private: false
            }
            return

        add_file: ()->
            # console.log "ADD FILE "
            @file_dialog_visible = true
            return

        add_folder: ()->
            # console.log "ADD FOLDER "
            @folder_dialog_visible = true
            return

        edit_file_or_folder: (row)->
            # console.log "EDIT ", row.uid, row.name, row.private
            if row.type_label == "Dossier"
                @folder.uid = row.uid
                @folder.name = row.name
                @folder.private = row.private
                @folder_dialog_visible = true
            else
                @file.uid = row.uid
                @file.name = row.name
                @file.private = row.private
                @file.file_type = row.type_label
                @file_dialog_visible = true
            return

        cancel_file: ()->
            @file_dialog_visible = false
            @$refs.file_upload.clearFiles()
            @reset_file()
            return

        cancel_folder: ()->
            @folder_dialog_visible = false
            @reset_folder()
            return

        delete_file_or_folder: (row)->
            # console.log "DELETE ", row.uid, row.name
            item = 'file'
            phrase = "Êtes-vous sûr·e de vouloir supprimer ce fichier ?"
            if row.type_label == "Dossier"
                item = 'folder'
                phrase = "Êtes-vous sûr·e de vouloir supprimer ce dossier et tout ce qu'il contient ?"
            self = @
            @$confirm(phrase, 'Confirmation', {
                confirmButtonText: 'Oui',
                cancelButtonText: 'Annuler'
                })
                .then ()->
                    # console.log "GED DELETE", item, row.uid
                    m.run('delete_object', [item, row.uid])
                    .then (resp)->
                        # console.log "DELETE GED", resp.body.data[item+'_deletion']
                        if resp.body.data[item+'_deletion'].ok
                            n.success()
                            self.get_ged_files()
                        else
                            n.gql_error("GED: delete_file_or_folder: then", resp.body.data[item+'_deletion'].message)
                    .catch (resp)->
                        n.catch_error(resp, "GED: delete_file_or_folder()")
                .catch (cancel)->
                    return

        save_file: ()->
            # console.log "SAVE FILE", @file.file_size
            self = @
            if @file.uid == '' and @file.file_name == ""
                n.file_error('Erreur', 'Un fichier est requis')
                return
            @file.user_uid = @selected_user
            @file.folder_uid = @folder_uid
            m.run('save_file', [@file, @$store.getters.current_company.uid])
            .then (resp)->
                if resp.body.data.file_form_mutation.form_ret == 'failed'
                    return n.access_denied()
                if resp.body.data.file_form_mutation.errors.length > 0
                    # console.log "ERRORS", resp.body.data.file_form_mutation.errors
                    self.errors = resp.body.data.file_form_mutation.errors.reduce(
                        (acc, el)->
                            acc[el.field] = el.messages
                            return acc
                    ,{})
                    n.form_error()
                else
                    self.errors = {}
                    n.success()
                    self.file_dialog_visible = false
                    if self.file.uid == ''
                        self.$refs.file_upload.clearFiles()
                    self.reset_file()
                    self.get_ged_files()
            .catch (resp)->
                n.catch_error(resp, "GED: save_file()")
            return

        save_folder: ()->
            # console.log "SAVE FOLDER"
            self = @
            @folder.user_uid = @selected_user
            @folder.parent_uid = @folder_uid
            m.run('save_folder', [@folder, @$store.getters.current_company.uid])
            .then (resp)->
                if resp.body.data.folder_form_mutation.form_ret == 'failed'
                    return n.access_denied()
                if resp.body.data.folder_form_mutation.errors.length > 0
                    # console.log "ERRORS", resp.body.data.folder_form_mutation.errors
                    self.errors = resp.body.data.folder_form_mutation.errors.reduce(
                        (acc, el)->
                            acc[el.field] = el.messages
                            return acc
                    ,{})
                    n.form_error()
                else
                    self.errors = {}
                    n.success()
                    self.folder_dialog_visible = false
                    self.reset_folder()
                    self.get_ged_files()
            .catch (resp)->
                n.catch_error(resp, "GED: save_folder()")
            return

        get_app_users: ()->
            self = @
            q.run('get_app_user_set', [@$store.getters.current_company.uid, 'ged'])
            .then (resp)->
                if resp.body.errors? and resp.body.errors.length > 0
                    for e in resp.body.errors
                        n.gql_error("GED: get_app_users: then", e.message)
                else
                    # console.log "GET APP USERS : ", resp.body.data.app_user_set
                    self.app_users = resp.body.data.app_user_set
                    if self.$store.state.user_datas.profiles.indexOf('distributor') == -1 && self.$store.state.user_datas.profiles.indexOf('superadmin') == -1
                        self.selected_user = self.$store.state.user_datas.app_user.uid
                    else
                        if resp.body.data.app_user_set.length > 0
                            self.selected_user = resp.body.data.app_user_set[0]['uid']
                    if resp.body.data.app_user_set.length > 0
                        self.get_ged_files()
            .catch (resp)->
                n.catch_error(resp, "GED: get_app_users()")
            return

        get_ged_files: ()->
            self = @
            q.run('get_ged_set', [@$store.getters.current_company.uid, @selected_user, @folder_uid])
            .then (resp)->
                if resp.body.errors? and resp.body.errors.length > 0
                    for e in resp.body.errors
                        n.gql_error("GED: get_ged_files: then", e.message)
                else
                    # console.log "GET GED FILE : ", resp.body.data.ged_set
                    self.ged_files = resp.body.data.ged_set
                    self.loading = false
            .catch (resp)->
                n.catch_error(resp, "GED: get_ged_files()")
            
    beforeMount: ()->
        @get_app_users()
}
